/** sequencer (docs/10) webhook shapes (docs/53 §6.3). See ./index.ts for the verification rule and the VERIFY note. */
import { z } from 'zod';

export const SequencerEvent = z.object({
  type: z.enum(['reply', 'bounce', 'unsubscribe', 'complaint']),
  eventId: z.string().max(128),
  at: z.iso.datetime({ offset: true }),
  businessRef: z.string().max(64),
  mailbox: z.string().max(254).optional(),
  replyClass: z.string().max(40).optional(),
});
